import { Box, Divider, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { PersonOff } from "@mui/icons-material";
import { EntityPicker } from "@gui/widgets/EntityPicker";
import type { ImpersonatableUser } from "@gui/infrastructure/pass-through/api";
import { useImpersonationMenuSectionViewModel } from "./ImpersonationMenuSection.vm";

interface ImpersonationMenuSectionProps {
	/** Developers only. An impersonated customer has no picker, so Stop is their only way back. */
	showPicker: boolean;
	isImpersonating: boolean;
	users: ImpersonatableUser[];
	impersonatedUser: ImpersonatableUser | null;
	isLoading: boolean;
	fetchUsers: () => void;
	onImpersonationPicked: (picked: ImpersonatableUser | null) => void;
	stopImpersonation: () => void;
	onClose: () => void;
}

/** The account menu's impersonation controls. */
export function ImpersonationMenuSection(props: ImpersonationMenuSectionProps) {
	const vm = useImpersonationMenuSectionViewModel(props);
	return (
		<>
			<Divider />
			{props.showPicker && (
				<Box
					tabIndex={-1}
					onFocus={vm.handleWrapperFocus}
					onKeyDown={vm.handleWrapperKeyDown}
					sx={{ px: 2, py: 1, width: 320, maxWidth: "100%" }}
				>
					<EntityPicker
						label="Impersonate user"
						size="small"
						options={props.users}
						loading={props.isLoading}
						value={props.impersonatedUser}
						getOptionLabel={(option) => `${option.name} (${option.email})`}
						isEqual={(option, value) => option.email === value.email}
						onOpen={props.fetchUsers}
						onChange={vm.handlePicked}
						inputRef={vm.pickerInputRef}
					/>
				</Box>
			)}
			{props.isImpersonating && (
				<MenuItem onClick={vm.handleStop}>
					<ListItemIcon>
						<PersonOff />
					</ListItemIcon>
					<ListItemText>Stop Impersonating</ListItemText>
				</MenuItem>
			)}
		</>
	);
}
